/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { CreateDocumentFromBlobRequestDto } from '../model/createDocumentFromBlobRequestDto';
// @ts-ignore
import { CreateDocumentReferenceRequestDto } from '../model/createDocumentReferenceRequestDto';
// @ts-ignore
import { CreateRelationshipRequestDto } from '../model/createRelationshipRequestDto';
// @ts-ignore
import { DocumentReferencesControllerCreate200Response } from '../model/documentReferencesControllerCreate200Response';
// @ts-ignore
import { DocumentReferencesControllerGetHistory200Response } from '../model/documentReferencesControllerGetHistory200Response';
// @ts-ignore
import { DocumentReferencesControllerListRelationships200Response } from '../model/documentReferencesControllerListRelationships200Response';
// @ts-ignore
import { DocumentReferencesControllerSearch200Response } from '../model/documentReferencesControllerSearch200Response';
// @ts-ignore
import { DocumentReferencesControllerSearchBySubjects200Response } from '../model/documentReferencesControllerSearchBySubjects200Response';
// @ts-ignore
import { PatchDocumentReferenceRequestDto } from '../model/patchDocumentReferenceRequestDto';
// @ts-ignore
import { SearchBySubjectsRequestDto } from '../model/searchBySubjectsRequestDto';
// @ts-ignore
import { SearchByTargetsRequestDto } from '../model/searchByTargetsRequestDto';
// @ts-ignore
import { UpdateDocumentReferenceRequestDto } from '../model/updateDocumentReferenceRequestDto';
// @ts-ignore
import { UpdateDocumentSecurityRequestDto } from '../model/updateDocumentSecurityRequestDto';
// @ts-ignore
import { UpdateDocumentStatusRequestDto } from '../model/updateDocumentStatusRequestDto';
// @ts-ignore
import { UpdateRelationshipRequestDto } from '../model/updateRelationshipRequestDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class DocumentReferencesService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  /**
  * @param consumes string[] mime-types
  * @return true: consumes contains 'multipart/form-data', false: otherwise
  */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Create a document reference
   * @param createDocumentReferenceRequestDto 
   */
  public async documentReferencesControllerCreate(createDocumentReferenceRequestDto: CreateDocumentReferenceRequestDto, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (createDocumentReferenceRequestDto === null || createDocumentReferenceRequestDto === undefined) {
      throw new Error('Required parameter createDocumentReferenceRequestDto was null or undefined when calling documentReferencesControllerCreate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references`,
        data: createDocumentReferenceRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Create a document reference from an existing blob
   * @param createDocumentFromBlobRequestDto 
   */
  public async documentReferencesControllerCreateFromBlob(createDocumentFromBlobRequestDto: CreateDocumentFromBlobRequestDto, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (createDocumentFromBlobRequestDto === null || createDocumentFromBlobRequestDto === undefined) {
      throw new Error('Required parameter createDocumentFromBlobRequestDto was null or undefined when calling documentReferencesControllerCreateFromBlob.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/from-blob`,
        data: createDocumentFromBlobRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Create a document relationship
   * @param id 
   * @param createRelationshipRequestDto 
   */
  public async documentReferencesControllerCreateRelationship(id: string, createRelationshipRequestDto: CreateRelationshipRequestDto, ): Promise<DocumentReferencesControllerListRelationships200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerCreateRelationship.');
    }
    if (createRelationshipRequestDto === null || createRelationshipRequestDto === undefined) {
      throw new Error('Required parameter createRelationshipRequestDto was null or undefined when calling documentReferencesControllerCreateRelationship.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships`,
        data: createRelationshipRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Delete document reference
   * @param id 
   */
  public async documentReferencesControllerDelete(id: string, ): Promise<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerDelete.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.delete({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Delete a document relationship
   * @param id 
   * @param relationshipId 
   */
  public async documentReferencesControllerDeleteRelationship(id: string, relationshipId: string, ): Promise<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerDeleteRelationship.');
    }
    if (relationshipId === null || relationshipId === undefined) {
      throw new Error('Required parameter relationshipId was null or undefined when calling documentReferencesControllerDeleteRelationship.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.delete({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships/${this.configuration.encodeParam({name: "relationshipId", value: relationshipId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get document reference by ID
   * @param id 
   * @param expand Fields to expand in the response
   */
  public async documentReferencesControllerGetById(id: string, expand?: Array<'document-type' | 'groups'>, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerGetById.');
    }

    const localVarQueryParameters = new URLSearchParams();
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}?${queryString}` : `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get document content (streaming)
   * @param id 
   */
  public async documentReferencesControllerGetContent(id: string, ): Promise<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerGetContent.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/content`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get document reference history
   * @param id 
   */
  public async documentReferencesControllerGetHistory(id: string, ): Promise<DocumentReferencesControllerGetHistory200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerGetHistory.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/history`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get a specific document relationship
   * @param id 
   * @param relationshipId 
   */
  public async documentReferencesControllerGetRelationship(id: string, relationshipId: string, ): Promise<DocumentReferencesControllerListRelationships200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerGetRelationship.');
    }
    if (relationshipId === null || relationshipId === undefined) {
      throw new Error('Required parameter relationshipId was null or undefined when calling documentReferencesControllerGetRelationship.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships/${this.configuration.encodeParam({name: "relationshipId", value: relationshipId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List all relationships for a document
   * @param id 
   */
  public async documentReferencesControllerListRelationships(id: string, ): Promise<DocumentReferencesControllerListRelationships200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerListRelationships.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Patch document reference (partial update)
   * @param id 
   * @param patchDocumentReferenceRequestDto 
   */
  public async documentReferencesControllerPatch(id: string, patchDocumentReferenceRequestDto: PatchDocumentReferenceRequestDto, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerPatch.');
    }
    if (patchDocumentReferenceRequestDto === null || patchDocumentReferenceRequestDto === undefined) {
      throw new Error('Required parameter patchDocumentReferenceRequestDto was null or undefined when calling documentReferencesControllerPatch.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.patch({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: patchDocumentReferenceRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Replace document file by uploading a new file
   * @param id 
   * @param documentTypeId Document type identifier
   * @param subject Subject of the document
   * @param author Author of the document
   * @param status Status of the document
   * @param security Security level of the document
   * @param updatedBy User performing the update
   * @param subjectType Subject type (patient, encounter, etc.)
   * @param metadata Additional metadata (JSON string for multipart/form-data)
   */
  public async documentReferencesControllerReplaceDocumentFile(id: string, documentTypeId: string, subject: string, author: string, status: string, security: string, updatedBy: string, subjectType?: string, metadata?: any, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerReplaceDocumentFile.');
    }
    if (documentTypeId === null || documentTypeId === undefined) {
      throw new Error('Required parameter documentTypeId was null or undefined when calling documentReferencesControllerReplaceDocumentFile.');
    }
    if (subject === null || subject === undefined) {
      throw new Error('Required parameter subject was null or undefined when calling documentReferencesControllerReplaceDocumentFile.');
    }
    if (author === null || author === undefined) {
      throw new Error('Required parameter author was null or undefined when calling documentReferencesControllerReplaceDocumentFile.');
    }
    if (status === null || status === undefined) {
      throw new Error('Required parameter status was null or undefined when calling documentReferencesControllerReplaceDocumentFile.');
    }
    if (security === null || security === undefined) {
      throw new Error('Required parameter security was null or undefined when calling documentReferencesControllerReplaceDocumentFile.');
    }
    if (updatedBy === null || updatedBy === undefined) {
      throw new Error('Required parameter updatedBy was null or undefined when calling documentReferencesControllerReplaceDocumentFile.');
    }

    const localVarHeaders = this.defaultHeaders;
      // to determine the Content-Type header
      const consumes: string[] = [
        'multipart/form-data'
      ];
    const canConsumeForm = this.canConsumeForm(consumes);
    let localVarFormParams: { append(param: string, value: any): any; };
    let localVarUseForm = false;
    let localVarConvertFormParamsToString = false;
    if (localVarUseForm) {
      localVarFormParams = new FormData();
    } else {
      localVarFormParams = new HttpParams({encoder: this.encoder});
    }
    if (documentTypeId !== undefined) {
      localVarFormParams = localVarFormParams.append('documentTypeId', <any>documentTypeId) as any || localVarFormParams;
    }
    if (subject !== undefined) {
      localVarFormParams = localVarFormParams.append('subject', <any>subject) as any || localVarFormParams;
    }
    if (subjectType !== undefined) {
      localVarFormParams = localVarFormParams.append('subjectType', <any>subjectType) as any || localVarFormParams;
    }
    if (author !== undefined) {
      localVarFormParams = localVarFormParams.append('author', <any>author) as any || localVarFormParams;
    }
    if (status !== undefined) {
      localVarFormParams = localVarFormParams.append('status', <any>status) as any || localVarFormParams;
    }
    if (security !== undefined) {
      localVarFormParams = localVarFormParams.append('security', <any>security) as any || localVarFormParams;
    }
    if (updatedBy !== undefined) {
      localVarFormParams = localVarFormParams.append('updatedBy', <any>updatedBy) as any || localVarFormParams;
    }
    if (metadata !== undefined) {
      localVarFormParams = localVarFormParams.append('metadata', <any>metadata) as any || localVarFormParams;
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/upload`,
          data: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search document references
   * @param documentTypeId Filter by document type ID
   * @param status Filter by document status
   * @param security Filter by security level
   * @param subject Filter by subject (partial match)
   * @param author Filter by author (partial match)
   * @param limit Number of results to return
   * @param offset Number of results to skip
   * @param expand Fields to expand in the response
   */
  public async documentReferencesControllerSearch(documentTypeId?: string, status?: 'open' | 'closed' | 'on_hold', security?: 'public' | 'confidential' | 'restricted' | 'very_restricted', subject?: string, author?: string, limit?: number, offset?: number, expand?: Array<'document-type' | 'groups'>, ): Promise<DocumentReferencesControllerSearch200Response> {

    const localVarQueryParameters = new URLSearchParams();
    if (documentTypeId !== undefined && documentTypeId !== null) {
      localVarQueryParameters.append('documentTypeId', String(documentTypeId));
    }
    if (status !== undefined && status !== null) {
      localVarQueryParameters.append('status', String(status));
    }
    if (security !== undefined && security !== null) {
      localVarQueryParameters.append('security', String(security));
    }
    if (subject !== undefined && subject !== null) {
      localVarQueryParameters.append('subject', String(subject));
    }
    if (author !== undefined && author !== null) {
      localVarQueryParameters.append('author', String(author));
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters.append('limit', String(limit));
    }
    if (offset !== undefined && offset !== null) {
      localVarQueryParameters.append('offset', String(offset));
    }
      if (expand) {
        expand.forEach((element) => {
          localVarQueryParameters.append('expand', String(element));
        });
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references?${queryString}` : `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search document references by subjects
   * Returns paginated document references matching any of the provided subjects (id + entity type pairs)
   * @param searchBySubjectsRequestDto 
   */
  public async documentReferencesControllerSearchBySubjects(searchBySubjectsRequestDto: SearchBySubjectsRequestDto, ): Promise<DocumentReferencesControllerSearchBySubjects200Response> {
    if (searchBySubjectsRequestDto === null || searchBySubjectsRequestDto === undefined) {
      throw new Error('Required parameter searchBySubjectsRequestDto was null or undefined when calling documentReferencesControllerSearchBySubjects.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/search-by-subjects`,
        data: searchBySubjectsRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Search document references by targets
   * Returns paginated document references matching any of the provided targets. Unlike search-by-subjects, the entity field is optional - allowing search by target ID alone.
   * @param searchByTargetsRequestDto 
   */
  public async documentReferencesControllerSearchByTargets(searchByTargetsRequestDto: SearchByTargetsRequestDto, ): Promise<DocumentReferencesControllerSearchBySubjects200Response> {
    if (searchByTargetsRequestDto === null || searchByTargetsRequestDto === undefined) {
      throw new Error('Required parameter searchByTargetsRequestDto was null or undefined when calling documentReferencesControllerSearchByTargets.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/search-by-targets`,
        data: searchByTargetsRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update document reference (full replacement)
   * @param id 
   * @param updateDocumentReferenceRequestDto 
   */
  public async documentReferencesControllerUpdate(id: string, updateDocumentReferenceRequestDto: UpdateDocumentReferenceRequestDto, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerUpdate.');
    }
    if (updateDocumentReferenceRequestDto === null || updateDocumentReferenceRequestDto === undefined) {
      throw new Error('Required parameter updateDocumentReferenceRequestDto was null or undefined when calling documentReferencesControllerUpdate.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateDocumentReferenceRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update a document relationship
   * @param id 
   * @param relationshipId 
   * @param updateRelationshipRequestDto 
   */
  public async documentReferencesControllerUpdateRelationship(id: string, relationshipId: string, updateRelationshipRequestDto: UpdateRelationshipRequestDto, ): Promise<DocumentReferencesControllerListRelationships200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerUpdateRelationship.');
    }
    if (relationshipId === null || relationshipId === undefined) {
      throw new Error('Required parameter relationshipId was null or undefined when calling documentReferencesControllerUpdateRelationship.');
    }
    if (updateRelationshipRequestDto === null || updateRelationshipRequestDto === undefined) {
      throw new Error('Required parameter updateRelationshipRequestDto was null or undefined when calling documentReferencesControllerUpdateRelationship.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.patch({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships/${this.configuration.encodeParam({name: "relationshipId", value: relationshipId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateRelationshipRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update document reference security level
   * @param id 
   * @param updateDocumentSecurityRequestDto 
   */
  public async documentReferencesControllerUpdateSecurity(id: string, updateDocumentSecurityRequestDto: UpdateDocumentSecurityRequestDto, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerUpdateSecurity.');
    }
    if (updateDocumentSecurityRequestDto === null || updateDocumentSecurityRequestDto === undefined) {
      throw new Error('Required parameter updateDocumentSecurityRequestDto was null or undefined when calling documentReferencesControllerUpdateSecurity.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/security`,
        data: updateDocumentSecurityRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update document reference status
   * @param id 
   * @param updateDocumentStatusRequestDto 
   */
  public async documentReferencesControllerUpdateStatus(id: string, updateDocumentStatusRequestDto: UpdateDocumentStatusRequestDto, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling documentReferencesControllerUpdateStatus.');
    }
    if (updateDocumentStatusRequestDto === null || updateDocumentStatusRequestDto === undefined) {
      throw new Error('Required parameter updateDocumentStatusRequestDto was null or undefined when calling documentReferencesControllerUpdateStatus.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/status`,
        data: updateDocumentStatusRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Upload a document and create a document reference
   * @param documentTypeId Document type identifier
   * @param subject Subject of the document
   * @param author Author of the document
   * @param status Status of the document
   * @param security Security level of the document
   * @param createdBy Creator identifier
   * @param subjectType Subject type (patient, encounter, etc.)
   * @param metadata Additional metadata (JSON string for multipart/form-data)
   */
  public async documentReferencesControllerUploadDocument(documentTypeId: string, subject: string, author: string, status: string, security: string, createdBy: string, subjectType?: string, metadata?: any, ): Promise<DocumentReferencesControllerCreate200Response> {
    if (documentTypeId === null || documentTypeId === undefined) {
      throw new Error('Required parameter documentTypeId was null or undefined when calling documentReferencesControllerUploadDocument.');
    }
    if (subject === null || subject === undefined) {
      throw new Error('Required parameter subject was null or undefined when calling documentReferencesControllerUploadDocument.');
    }
    if (author === null || author === undefined) {
      throw new Error('Required parameter author was null or undefined when calling documentReferencesControllerUploadDocument.');
    }
    if (status === null || status === undefined) {
      throw new Error('Required parameter status was null or undefined when calling documentReferencesControllerUploadDocument.');
    }
    if (security === null || security === undefined) {
      throw new Error('Required parameter security was null or undefined when calling documentReferencesControllerUploadDocument.');
    }
    if (createdBy === null || createdBy === undefined) {
      throw new Error('Required parameter createdBy was null or undefined when calling documentReferencesControllerUploadDocument.');
    }

    const localVarHeaders = this.defaultHeaders;
      // to determine the Content-Type header
      const consumes: string[] = [
        'multipart/form-data'
      ];
    const canConsumeForm = this.canConsumeForm(consumes);
    let localVarFormParams: { append(param: string, value: any): any; };
    let localVarUseForm = false;
    let localVarConvertFormParamsToString = false;
    if (localVarUseForm) {
      localVarFormParams = new FormData();
    } else {
      localVarFormParams = new HttpParams({encoder: this.encoder});
    }
    if (documentTypeId !== undefined) {
      localVarFormParams = localVarFormParams.append('documentTypeId', <any>documentTypeId) as any || localVarFormParams;
    }
    if (subject !== undefined) {
      localVarFormParams = localVarFormParams.append('subject', <any>subject) as any || localVarFormParams;
    }
    if (subjectType !== undefined) {
      localVarFormParams = localVarFormParams.append('subjectType', <any>subjectType) as any || localVarFormParams;
    }
    if (author !== undefined) {
      localVarFormParams = localVarFormParams.append('author', <any>author) as any || localVarFormParams;
    }
    if (status !== undefined) {
      localVarFormParams = localVarFormParams.append('status', <any>status) as any || localVarFormParams;
    }
    if (security !== undefined) {
      localVarFormParams = localVarFormParams.append('security', <any>security) as any || localVarFormParams;
    }
    if (createdBy !== undefined) {
      localVarFormParams = localVarFormParams.append('createdBy', <any>createdBy) as any || localVarFormParams;
    }
    if (metadata !== undefined) {
      localVarFormParams = localVarFormParams.append('metadata', <any>metadata) as any || localVarFormParams;
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-clinical-document/document-references/upload`,
          data: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
